import Reveal from "@/components/Reveal";
import { IMAGES, INSTAGRAM_URL } from "@/lib/images";
import { Instagram, ArrowRight } from "lucide-react";

export default function InstagramGallery() {
  return (
    <section data-testid="instagram" className="bg-white text-[#1C1917] py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10">
        <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div>
            <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">Follow The Work</span>
            <h2 className="font-serif text-5xl sm:text-7xl font-medium leading-[0.9] tracking-tight mt-4">@slavic.lashes.brows</h2>
          </div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow"
            className="group inline-flex items-center gap-3 bg-[#1C1917] hover:bg-[#C5B382] text-white hover:text-[#1C1917] text-[11px] font-semibold tracking-[0.15em] uppercase px-7 py-4 rounded-full transition-colors duration-300 self-start"
          >
            <Instagram size={16} /> Follow on Instagram
            <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {IMAGES.gallery.map((src, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06}>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`instagram-tile-${i}`}
                className="group relative block aspect-square overflow-hidden rounded-[1.25rem] shadow-card"
              >
                <img src={src} alt={`Lash work ${i + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-[#1C1917]/0 group-hover:bg-[#1C1917]/35 transition-all duration-300 flex items-center justify-center">
                  <Instagram size={26} className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
